import { CustomTheme } from "@luna-restaurant/ui";

const ColorPalette = {
  // Primary
  lime100: "#F3F3F3",
  lime90: "#DDEBC6",
  lime80: "#C4E199",
  lime70: "#ABD570",
  lime60: "#90C849",
  lime50: "#75B62C",
  lime40: "#5D991A",
  lime30: "#3F6F0D",
  lime20: "#213E05",
  lime10: "#050A00",

  // Secondary
  spinach100: "#F5FAF7",
  spinach90: "#C6F3D1",
  spinach80: "#96E6A9",
  spinach70: "#66D680",
  spinach60: "#41C35F",
  spinach50: "#27AE46",
  spinach40: "#159432",
  spinach30: "#0A6F22",
  spinach20: "#044313",
  spinach10: "#000A03",

  // gray
  white100: "#FFFFFF",
  gray90: "#E5E5E5",
  gray80: "#CCCCCC",
  gray70: "#B2B2B2",
  gray60: "#999999",
  gray50: "#808080",
  gray40: "#666666",
  gray30: "#4D4D4D",
  gray20: "#333333",
  gray10: "#1A1A1A",

  // special
  carrot100: "#F4EEE7", // dessertBackground
  carrot90: "#F4D0A8",
  carrot80: "#F2B26E",
  carrot70: "#EE9B41",
  carrot60: "#E9881E",
  carrot50: "#DF7A0D",
  carrot40: "#BD6709",
  carrot30: "#894A06",
  carrot20: "#4F2A03", // dessertText

  banana90: "#FAEEBF",
  banana50: "#EABC00",

  grapefruit90: "#F5D0D3",
  grapefruit50: "#D64351",
};

export const DefaultTheme: CustomTheme = {
  dark: false,
  colors: {
    // base colors
    primary: ColorPalette.lime80,
    background: ColorPalette.white100,
    card: ColorPalette.spinach10,
    text: ColorPalette.lime10,
    border: ColorPalette.spinach30,
    notification: ColorPalette.lime90,
    semiMuted: ColorPalette.gray30,
    muted: ColorPalette.gray50,
    mutedBorder: ColorPalette.gray90,
    lightMuted: ColorPalette.gray80,

    // special colors
    info: "#0A7EA4",
    success: ColorPalette.spinach40,
    successLight: ColorPalette.lime70,
    successLighter: ColorPalette.lime90,
    warning: ColorPalette.banana50,
    warningLight: ColorPalette.banana90,
    danger: ColorPalette.grapefruit50,
    dangerLight: ColorPalette.grapefruit90,
    sectionBackground: ColorPalette.lime100,
    tableRowHover: "#F5F9EE",
    modalBackground: ColorPalette.gray30,
    black: "rgb(5,10,0)",

    // menu colors
    menuA: ColorPalette.spinach30,
    menuB: ColorPalette.spinach20,
    menuD: ColorPalette.carrot20,

    palette: {
      banana90: ColorPalette.banana90,
      carrot100: ColorPalette.carrot100,
      carrot40: ColorPalette.carrot40,
      carrot20: ColorPalette.carrot20,
      lime70: ColorPalette.lime70,
      lime40: ColorPalette.lime40,
      spinach30: ColorPalette.spinach30,
      spinach40: ColorPalette.spinach40,
      spinach20: ColorPalette.spinach20,
      spinach50: ColorPalette.spinach50,
      lime50: ColorPalette.lime50,
      spinach90: ColorPalette.spinach90,
      gray80: ColorPalette.gray80,
      gray20: ColorPalette.gray20,
    },
  },
  fonts: {
    regular: {
      fontFamily: "PoppinsRegular",
      fontWeight: "400",
    },
    medium: {
      fontFamily: "PoppinsMedium",
      fontWeight: "500",
    },
    semiBold: {
      fontFamily: "PoppinsMedium",
      fontWeight: "600",
    },
    bold: {
      fontFamily: "PoppinsBold",
      fontWeight: "700",
    },
    heavy: {
      fontFamily: "PoppinsBold",
      fontWeight: "900",
    },
    display: {
      fontFamily: "BrushUpRegular",
      fontWeight: "400",
    },
    headline: {
      fontFamily: "BrushUpRegular",
      fontWeight: "500",
    },
  },
};
